import React from "react";
import { InputTextarea } from "primereact/inputtextarea";
import { Badge } from "primereact/badge";
import { Splitter, SplitterPanel } from "primereact/splitter";
import { SectionSaveButton } from "./SectionSaveButton";

interface ComparisonPanelProps {
    originalText: string;
    editableText: string;
    sectionKey: string;
    hasBeenEdited: boolean;
    onTextChange: (value: string) => void;
    onSave: () => void;
}

export const ComparisonPanel: React.FC<ComparisonPanelProps> = ({
    originalText,
    editableText,
    sectionKey,
    hasBeenEdited,
    onTextChange,
    onSave
}) => {
    const getCharacterCount = (text: string): number => {
        return text.length;
    };

    return (
        <Splitter className="mb-4" style={{ height: '400px' }}>
            {/* Original Text Panel */}
            <SplitterPanel className="flex align-items-center justify-content-center" size={50}>
                <div className="w-full h-full p-3">
                    <div className="flex align-items-center justify-content-between mb-3">
                        <h4 className="m-0 text-700">
                            Original Text
                        </h4>
                        <div className="flex gap-2">
                            <Badge 
                                value={`${getCharacterCount(originalText)} chars`} 
                                severity="info" 
                                className="text-xs"
                            />
                        </div>
                    </div>
                    <InputTextarea 
                        value={originalText || 'No original text available'} 
                        readOnly
                        rows={12}
                        className="w-full" 
                        style={{ 
                            resize: 'none', 
                            height: '320px',
                            backgroundColor: '#f8f9fa',
                            color: '#495057',
                            opacity: 1,
                            overflow: 'auto',
                            lineHeight: '2rem'
                        }}
                    />
                </div>
            </SplitterPanel>

            {/* AI Enhanced Text Panel */}
            <SplitterPanel className="flex align-items-center justify-content-center" size={50}>
                <div className="w-full h-full p-3">
                    <div className="flex align-items-center justify-content-between mb-3">
                        <h4 className="m-0 text-primary">
                            <i className="pi pi-sparkles mr-2"></i>
                            AI Enhanced Text
                        </h4>
                        <div className="flex align-items-center gap-2">
                            <Badge 
                                value={`${getCharacterCount(editableText)} chars`} 
                                severity="info" 
                                className="text-xs"
                            />
                            <SectionSaveButton
                                sectionKey={sectionKey}
                                hasBeenEdited={hasBeenEdited}
                                editableText={editableText}
                                onSave={onSave}
                            />
                        </div>
                    </div>
                    <InputTextarea 
                        value={editableText} 
                        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => onTextChange(e.target.value)} 
                        rows={12}
                        className="w-full border-primary-200 focus:border-primary-500" 
                        placeholder="AI enhanced text will appear here..."
                        style={{ resize: 'none', height: '320px', lineHeight: '2rem' }}
                    />
                </div>
            </SplitterPanel>
        </Splitter>
    );
};